<template>
  <div class="page-editor">
    <mt-header fixed title="修改经销商信息">
      <router-link to="/ent/dealer" slot="left">
        <mt-button icon="back">返回</mt-button>
      </router-link>
    </mt-header>
    <mt-field label="经销商名称" placeholder="请输入经销商名称" v-model="dealerInfo.name" class="required"></mt-field>
    <mt-field label="联系人" placeholder="请输入联系人" v-model="dealerInfo.linkman" class="required"></mt-field>
    <mt-field label="联系电话" placeholder="请输入联系电话" v-model="dealerInfo.telephone" class="required"></mt-field>
    <mt-field label="联系地址" placeholder="请输入联系地址" v-model="dealerInfo.address" class="required" type="textarea" rows="3"></mt-field>

    <div class="page-btn">
      <mt-button type="primary" size="large" @click.native="saveEnt">提交</mt-button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import "mint-ui/lib/style.css";
import { Toast, Cell, Button, Field, Header } from "mint-ui";
export default {
  data() {
    return {
      dealerInfo: {}
    };
  },
  props: ["dealerId"],
  methods: {
    checkData() {
      return (
        this.dealerInfo &&
        this.dealerInfo.address &&
        this.dealerInfo.linkman &&
        this.dealerInfo.telephone
      );
    },
    saveEnt() {
      if(!this.checkData()){
        Toast("请完善必填项目！");
        return;
      }

      this.$http
        .post(this.GLOBAL.serverUrl + "/ent/dealer", this.dealerInfo)
        .then(resp => {
          if (resp.body.code == 200) {
            this.$router.push("/ent/dealer");
          } else if (resp.body.code == 500) {
            Toast("操作失败！");
          }
        });
    }
  },
  mounted() {
    if( this.dealerId){
      this.$http.get(this.GLOBAL.serverUrl + "/ent/dealer?id=" + this.dealerId).then(resp => {
        if (resp.body.code == 200) 
          this.dealerInfo = resp.body.data;
        else if (resp.body.code == 500) 
          Toast("获取数据失败，请稍后再试！");
      });
    }
  }
};
</script>
<style scoped>
.page-editor {
  padding-top: 40px;
}
.mint-cell.is-textarea .mint-cell-title {
  padding: 0.5rem !important;
}
.page-btn {
  margin-top: 1rem;
  padding: 1rem;
}
</style>